import { render, staticRenderFns } from "./hzbhome.vue?vue&type=template&id=157ccf26&"
import script from "./hzbhome.vue?vue&type=script&lang=ts&"
export * from "./hzbhome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports